<div class="delete" :style="`width: ${size}px; height: ${size}px`" @click="$emit('delete')"><span></span></div>